export default () => {
    // Author: Codems AB
    (function($){
        // Extends la fonction wpcf7.taggen.update de wpcf7
        // permet d'inclurer du contenu personalisé dans le champ d'instertion
        if(window.wpcf7 !== undefined && wpcf7.taggen !== undefined){
            var base_update_func = wpcf7.taggen.update;
            if(base_update_func){
                wpcf7.taggen.update = function($form) {
                    base_update_func.apply(this, arguments);
                    var id = $form.attr( 'data-id' );
        
                    if(id == 'cdm_row'){
                        $form.find( 'input.tag' ).each( function() {
                            $( this ).val( '<div class="form-row">\n</div>' );
                        } );
                    }else if(id == 'cdm_col') {
                        var cols = $form.find( 'input[name="cols"]' ).val() || 6;
                        $form.find( 'input.tag' ).each( function() {
                            $( this ).val( `<div class="input-wrapper col-${cols}">\n\n</div>` );
                        } );
                    }
                };
            }
        }
        })(jQuery)
}

